<template>
  <div class="settlement-list">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :model="searchForm" inline>
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入用户昵称"
            clearable
            style="width: 200px"
          />
        </el-form-item>
        
        <el-form-item label="项目">
          <el-select v-model="searchForm.teamId" placeholder="请选择" clearable style="width: 150px">
            <el-option
              v-for="team in teamOptions"
              :key="team.id"
              :label="team.name"
              :value="team.id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="支付状态">
          <el-select v-model="searchForm.payStatus" placeholder="请选择" clearable style="width: 120px">
            <el-option label="未支付" :value="0" />
            <el-option label="已支付" :value="1" />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 表格 -->
    <el-card class="table-card mt-20">
      <el-table :data="settlementList" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="结算人" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.settlePerson || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算给" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.settleTo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来源" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.recordSource === '包工头代记' ? 'warning' : 'success'" size="small">
              {{ scope.row.recordSource || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="teamName" label="项目" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.teamName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="结算金额" width="120">
          <template slot-scope="scope">
            <span class="text-primary">¥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结算日期" width="120">
          <template slot-scope="scope">
            {{ scope.row.settleDate || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="100">
          <template slot-scope="scope">
            {{ getPayMethodText(scope.row.payMethod) }}
          </template>
        </el-table-column>
        <el-table-column label="支付状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.payStatus === 1 ? 'success' : 'warning'">
              {{ scope.row.payStatus === 1 ? '已支付' : '未支付' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.remark">{{ scope.row.remark }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.payStatus === 0"
              type="text"
              class="text-success"
              @click="handlePay(scope.row)"
            >
              确认支付
            </el-button>
            <span v-else class="text-muted">已支付</span>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        class="mt-20"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNum"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'SettlementList',
  data() {
    return {
      searchForm: {
        keyword: '',
        teamId: null,
        payStatus: null
      },
      teamOptions: [],
      settlementList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false
    }
  },
  created() {
    this.loadTeamOptions()
    this.loadSettlementList()
  },
  methods: {
    async loadTeamOptions() {
      try {
        const res = await this.$http.get('/admin/team/list', { params: { pageNum: 1, pageSize: 9999 } })
        this.teamOptions = res.records || []
      } catch (error) {
        console.error(error)
      }
    },
    
    async loadSettlementList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchForm
        }
        const res = await this.$http.get('/admin/settlement/list', { params })
        this.settlementList = res.records || []
        this.total = res.total || 0
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.pageNum = 1
      this.loadSettlementList()
    },
    
    handleReset() {
      this.searchForm = {
        keyword: '',
        teamId: null,
        payStatus: null
      }
      this.handleSearch()
    },
    
    handlePageChange(page) {
      this.pageNum = page
      this.loadSettlementList()
    },
    
    handleSizeChange(size) {
      this.pageSize = size
      this.handleSearch()
    },
    
    getPayMethodText(method) {
      const methods = { 1: '现金', 2: '微信', 3: '银行卡' }
      return methods[method] || '未知'
    },
    
    handleView(row) {
      this.$alert(`
        <p>结算人：${row.settlePerson || '-'}</p>
        <p>结算对象：${row.settleTo || '-'}</p>
        <p>项目：${row.teamName || '-'}</p>
        <p>结算金额：¥${row.amount}</p>
        <p>结算日期：${row.settleDate || '-'}</p>
        <p>支付方式：${this.getPayMethodText(row.payMethod)}</p>
        <p>支付状态：${row.payStatus === 1 ? '已支付' : '未支付'}</p>
        <p>备注：${row.remark || '无'}</p>
      `, '结算详情', {
        dangerouslyUseHTMLString: true
      })
    },

    async handlePay(row) {
      try {
        await this.$confirm('确定该结算已支付吗？', '提示', {
          type: 'warning'
        })
        await this.$http.post(`/admin/settlement/confirmPay/${row.id}`)
        this.$message.success('操作成功')
        this.loadSettlementList()
      } catch (error) {
        if (error !== 'cancel') {
          console.error(error)
        }
      }
    },
    
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped lang="scss">
.settlement-list {
  .search-card {
    ::v-deep .el-card__body {
      padding-bottom: 0;
    }
  }
  
  .text-primary {
    color: #409EFF;
    font-weight: bold;
  }
  
  .text-success {
    color: #67C23A;
  }
  
  .text-muted {
    color: #999;
  }
}
</style>
